import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import apiProvider from '../../apiProvider/api';
import { IMAGE_URL } from '../../network/apiClient';
const ItemsPerPage = 10; // Number of items per page



const LatestRegisteredOne = () => {
    const [userList, setUserList] = useState([])
    const [purchaseList, setPurchaseList] = useState([])
    const [purchaseCount, setPurchaseCount] = useState(0)
    const [usrCount, setUserCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);


    const fetchData = async () => {
        try {

            const getUserList = await apiProvider.getUsers();
            console.log(getUserList, "result-user");
            if (getUserList && getUserList.response && getUserList.response.data.data) {
                setUserList(getUserList.response.data.data.slice(-10).reverse());
                setUserCount(getUserList.response.data.data.length);
            }

            const result = await apiProvider.getPurchaseDetails();
            console.log(result, "result");
            if (result && result.response && result.response.data && result.response.data.data) {
                setPurchaseList(result.response.data.data.courses);
                setPurchaseCount(result.response.data.data.courses.length)
            }


        } catch (error) {
            console.error("Error fetching category data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    // Calculate total pages
    const totalPages = Math.ceil(purchaseList && purchaseList.length > 0 && purchaseList.length / ItemsPerPage);

    // Get the current page's data
    const startIndex = (currentPage - 1) * ItemsPerPage;
    const endIndex = startIndex + ItemsPerPage;
    const currentData = purchaseList && purchaseList.length && purchaseList?.slice(-10).reverse() || [];
    console.log(currentData, "currentData");

    return (
        <div className="col-xxl-12 col-xl-12">
            <div className="card h-100">
                <div className="card-body p-24">
                    <div className="d-flex flex-wrap align-items-center gap-1 justify-content-between mb-16">
                        <ul
                            className="nav border-gradient-tab nav-pills mb-0"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center active"
                                    id="pills-to-do-list-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-to-do-list"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-to-do-list"
                                    aria-selected="true"
                                >
                                    Latest Registered Users
                                    <span className="text-sm fw-semibold py-6 px-12 bg-neutral-500 rounded-pill text-white line-height-1 ms-12 notification-alert">
                                        {usrCount}
                                    </span>
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center"
                                    id="pills-recent-leads-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-recent-leads"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-recent-leads"
                                    aria-selected="false"
                                    tabIndex={-1}
                                >
                                    Recent Course Purchases
                                    {/* <span className="text-sm fw-semibold py-6 px-12 bg-neutral-500 rounded-pill text-white line-height-1 ms-12 notification-alert">
                                        35
                                    </span> */}
                                </button>
                            </li>
                        </ul>
                        {/* <Link
                            to="#"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link> */}
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        <div
                            className="tab-pane fade show active"
                            id="pills-to-do-list"
                            role="tabpanel"
                            aria-labelledby="pills-to-do-list-tab"
                            tabIndex={0}
                        >
                            <table className="table bordered-table sm-table mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <div className="d-flex align-items-center gap-10">
                                                S.No
                                            </div>
                                        </th>
                                        {/* <th scope="col">Id</th> */}
                                        <th scope="col">Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col" className="text-center">
                                            Status
                                        </th>
                                        {/* <th scope="col" className="text-center">
                                                               Action
                                                           </th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {userList.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>
                                                <div className="d-flex align-items-center gap-10">
                                                    {index + 1}
                                                </div>
                                            </td>
                                            {/* <td>{item.id}</td> */}
                                            <td>
                                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                                    {item.userName}
                                                </span>
                                            </td>
                                            <td>{item.email}</td>
                                            <td className="text-center">
                                                <span className={`${item.status === "Active"
                                                    ? "bg-success-focus text-success-600 border border-success-main"
                                                    : "bg-danger-200 text-dander-600 border border-danger-400"
                                                    } px-24 py-4 radius-4 fw-medium text-sm`}>
                                                    {item.status}
                                                </span>
                                            </td>
                                            {/* <td>
                                                                   <div className="text-center">
                                                                       <button
                                                                           className="btn px-18 py-11 text-primary-light"
                                                                           type="button"
                                                                           data-bs-toggle="dropdown"
                                                                           aria-expanded="false"
                                                                       >
                                                                           <Icon icon="entypo:dots-three-vertical" className="menu-icon" />
                                                                       </button>
                                                                       <ul className="dropdown-menu">
                                                                           {["Active", "Inactive"].map(status => (
                                                                               <li key={status}>
                                                                                   <Link
                                                                                       className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 
                                                                                                                      ${item.status === status ? "bg-primary-600 text-white" : ""}`}
                                                                                       to="#"
                                                                                       onClick={() => handleStatusChange(item.id, status)}
                                                                                   >
                                                                                       {status}
                                                                                   </Link>
                                                                               </li>
                                                                           ))}
                                                                       </ul>
                                                                   </div>
                                                               </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-recent-leads"
                            role="tabpanel"
                            aria-labelledby="pills-recent-leads-tab"
                            tabIndex={0}
                        >
                            <div className="table-responsive scroll-sm">
                                <table className="table bordered-table sm-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">
                                                <div className="d-flex align-items-center gap-10">
                                                    S.No
                                                </div>
                                            </th>
                                            <th scope="col">User Name</th>
                                            <th scope="col">Course Name</th>
                                            <th scope="col">Image</th>
                                            {/* <th>Type</th> */}
                                            <th scope="col">Duration</th>
                                            <th scope="col">Language</th>
                                            <th scope="col">Purchase Status</th>
                                            <th scope="col">Purchase Date</th>


                                            {/* <th scope="col" className="text-center">
                                                Status
                                            </th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData && currentData.length > 0 && currentData.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>
                                                    <div className="d-flex align-items-center gap-10">
                                                        {index + 1}
                                                    </div>
                                                </td>
                                                {/* <td>{item.id}</td> */}
                                                <td>
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                        {item.userName}
                                                    </span>
                                                </td>
                                                <td className="pro-title text-decoration-none">
                                                    <p className="pro-title text-decoration-none">{item.categoryName}</p>
                                                    <p>{item.courseName}</p>
                                                </td>
                                                <td className="pro-thumbnail">
                                                    <img
                                                        src={IMAGE_URL + item.categoryImage}
                                                        alt="Product"
                                                        style={{ width: "70px" }}
                                                    />
                                                </td>

                                                <td>3 Days</td>
                                                <td>{item.lang}</td>
                                                <td>{item.paymentStatus}</td>
                                                <td>{formatDate(item.purchaseDate)}</td>

                                                {/* <td className="text-center">
                                                <span className={`${item.isActive
                                                    ? "bg-success-focus text-success-600 border border-success-main"
                                                    : "bg-neutral-200 text-neutral-600 border border-neutral-400"
                                                    } px-24 py-4 radius-4 fw-medium text-sm`}>
                                                    {item.isActive}
                                                </span>
                                            </td> */}
                                                <td className="text-center">
                                                    <div className="d-flex align-items-center gap-10 justify-content-center">
                                                        {/* <button
                                                        type="button"
                                                        className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon
                                                            icon="majesticons:eye-line"
                                                            className="icon text-xl"
                                                        />
                                                    </button> */}
                                                        {/* <button
                                                        type="button"
                                                        className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon icon="lucide:edit" className="menu-icon" />
                                                    </button> */}
                                                        {/* <button
                                                        type="button"
                                                        className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    >
                                                        <Icon
                                                            icon="fluent:delete-24-regular"
                                                            className="menu-icon"
                                                        />
                                                    </button> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>

                                </table>
                                <br>
                                </br>
                                {/* <center style={{ display: "flex", justifyContent: "center" }}>
                                    No course purchases yet.
                                </center> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LatestRegisteredOne